<ng-template #noRoles>
  <div class="m-4">Please select a role in the sidebar.</div>
</ng-template>

<div class="d-flex">
  <div class="sidebar-content px-4">
    <div class="card mt-4">
      <div class="card-header">
        <h3>General Permission</h3>
        <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="lock-open" size="lg" [fixedWidth]="true"></fa-icon>
      </div>
      <div *ngIf="selected.length; else noRoles" class="card-body">
        <table *ngIf="general" class="table table-responsive">
          <thead>
            <tr>
              <th class="text-center" colspan="3">Subject</th>
              <th class="text-start" ngbTooltip="Role can access content in node" container="body">Read</th>
              <th class="text-start" ngbTooltip="Role can edit content in node" container="body">Write</th>
              <th class="text-start" ngbTooltip="Role can delete content in node" container="body">Delete</th>
              <th class="text-center">Information</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let perm of general">
              <td class="text-start">
                <ng-container *ngIf="!perm.subject.sub">
                  <label class="fw-bold">{{ perm.subject.base }}</label>
                  <fa-icon *ngIf="perm.warning" icon="info-circle" class="mx-1" [ngbTooltip]="perm.warning"></fa-icon>
                </ng-container>
              </td>
              <td class="text-start">
                <ng-container *ngIf="perm.subject.sub">
                  <label>{{ perm.subject.sub }}</label>
                  <fa-icon *ngIf="perm.warning" icon="info-circle" class="mx-1" [ngbTooltip]="perm.warning"></fa-icon>
                </ng-container>
              </td>
              <app-permission-toggles
                [config]="perm"
                [disabled]="disabled || perm.disabled"
                (change)="permissionChanged(perm.subject, $event)"
              ></app-permission-toggles>
              <td class="text-start">
                <label *ngIf="perm.conflict" class="text-danger">{{ perm.conflict }}</label>
                <label *ngIf="!perm.conflict" class="text-secondary">{{ perm.description }}</label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card my-4">
      <div class="card-header">
        <h3>
          Access Control
          <a href="/help/permissions" target="_blank" rel="noopener noreferrer" ngbTooltip="Permissions & roles guide" container="body">
            <fa-icon icon="info-circle" class="mx-1"></fa-icon>
          </a>
        </h3>
        <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="key" size="lg" [fixedWidth]="true"></fa-icon>
      </div>
      <div *ngIf="selected.length else noRoles" class="card-body">
        <app-permission-table [roles]="selected" [subject]="nodeSubject" [updates]="nodeUpdates" [resources]="true"></app-permission-table>
      </div>
    </div>
  </div>

  <div class="sidebar-right p-3">
    <app-role-sidebar [roles]="roles" [(selected)]="selected" (selectedChange)="rebuildGeneralPermissions()"></app-role-sidebar>
  </div>
</div>
